import {
    CcReviewReviewItem,
    CcReviewReviewRevision,
    CcReviewReviewItemState,
    CcReviewReviewHistory,
    CcReviewReviewTempAnswer,
} from "server/models"
import { StateType, OrderType } from "client/utils"
import { NestedHistory } from "client/components"

export interface CcReviewReviewProps {
    reviewItemId: number
    revisionId: number
}

export type ReviewReviewItemList = { [itemId: number]: CcReviewReviewItem }
export type ReviewReviewItemValidation = { [key in keyof CcReviewReviewItem]?: string}

export type ReviewReviewRevisionList = { [itemId: number]: readonly CcReviewReviewRevision[] }
export type ReviewReviewRevisionActiveList = { [itemId: number]: CcReviewReviewRevision }
export type ReviewReviewRevisionValidation = { [key in keyof CcReviewReviewRevision]?: string }

export type ReviewReviewStateList = { [itemId: number]: CcReviewReviewItemState }

export type ReviewReviewHistoryList = { [itemId: number]: CcReviewReviewHistory[] }
export type ReviewReviewHistoryNestedList = { [itemId: number]: NestedHistory[] }
export type ReviewReviewHistoryValidation = { [key in keyof CcReviewReviewHistory]?: string }

export type ReviewReviewTempAnswerByUser = { [userId: number]: CcReviewReviewTempAnswer }
export type ReviewReviewTempAnswerList = { [itemId: number]: ReviewReviewTempAnswerByUser }
export type ReviewReviewTempAnswerValidation = { [key in keyof CcReviewReviewTempAnswer]?: string }

export interface CcReviewReviewState {
    // list
    tableClass: string
    showColumnSettings: boolean

    itemList: ReviewReviewItemList
    itemIds: readonly number[]

    revisionList: ReviewReviewRevisionList
    revisionActiveList: ReviewReviewRevisionActiveList

    itemStateList: ReviewReviewStateList
    itemHistoryList: ReviewReviewHistoryList
    tempAnswerList: ReviewReviewTempAnswerList

    selected: readonly number[]

    sortColumn: keyof CcReviewReviewItem
    sortOrder: OrderType

    loadState: StateType
    reloadList: boolean

    // popup menu
    active: CcReviewReviewItem
    menuShow: boolean
    menuTarget: any

    showConfirmDelete: boolean

    // view history and edit item
    itemDetails: CcReviewReviewItem
    itemState: CcReviewReviewItemState
    itemHistory: CcReviewReviewHistory[]
    tempAnswers: ReviewReviewTempAnswerByUser
    tempAnswerHistory: CcReviewReviewHistory
    reloadAnswer: boolean
    reloadEdit: boolean
}

// list
export const CC_REVIEW_REVIEW_COLUMN_SETTINGS = "CC_REVIEW_REVIEW_COLUMN_SETTINGS"

export const CC_REVIEW_REVIEW_ITEM_LIST = "CC_REVIEW_REVIEW_ITEM_LIST"
export const CC_REVIEW_REVIEW_ITEM_IDS = "CC_REVIEW_REVIEW_ITEM_IDS"

export const CC_REVIEW_REVIEW_REVISION_LIST = "CC_REVIEW_REVIEW_REVISION_LIST"
export const CC_REVIEW_REVIEW_REVISION_ACTIVE_LIST = "CC_REVIEW_REVIEW_REVISION_ACTIVE_LIST"

export const CC_REVIEW_REVIEW_ITEM_STATE_LIST = "CC_REVIEW_REVIEW_ITEM_STATE_LIST"
export const CC_REVIEW_REVIEW_ITEM_HISTORY_LIST = "CC_REVIEW_REVIEW_ITEM_HISTORY_LIST"
export const CC_REVIEW_REVIEW_TEMP_ANSWER_LIST = "CC_REVIEW_REVIEW_TEMP_ANSWER_LIST"

export const CC_REVIEW_REVIEW_SELECTED = "CC_REVIEW_REVIEW_SELECTED"

export const CC_REVIEW_REVIEW_SORT = "CC_REVIEW_REVIEW_SORT"
export const CC_REVIEW_REVIEW_LOAD_STATE = "CC_REVIEW_REVIEW_LOAD_STATE"
export const CC_REVIEW_REVIEW_RELOAD_LIST = "CC_REVIEW_REVIEW_RELOAD_LIST"

// popup menu
export const CC_REVIEW_REVIEW_ACTIVE = "CC_REVIEW_REVIEW_ACTIVE"
export const CC_REVIEW_REVIEW_POPUP_MENU_SHOW = "CC_REVIEW_REVIEW_POPUP_MENU_SHOW"
export const CC_REVIEW_REVIEW_POPUP_MENU_TARGET = "CC_REVIEW_REVIEW_POPUP_MENU_TARGET"
export const CC_REVIEW_REVIEW_SHOW_CONFIRM_DELETE = "CC_REVIEW_REVIEW_SHOW_CONFIRM_DELETE"

// view history and edit item
export const CC_REVIEW_REVIEW_ITEM_DETAILS = "CC_REVIEW_REVIEW_ITEM_DETAILS"
export const CC_REVIEW_REVIEW_ITEM_STATE = "CC_REVIEW_REVIEW_ITEM_STATE"
export const CC_REVIEW_REVIEW_ITEM_HISTORY = "CC_REVIEW_REVIEW_ITEM_HISTORY"
export const CC_REVIEW_REVIEW_TEMP_ANSWERS = "CC_REVIEW_REVIEW_TEMP_ANSWERS"
export const CC_REVIEW_REVIEW_TEMP_ANSWER_HISTORY = "CC_REVIEW_REVIEW_TEMP_ANSWER_HISTORY"
export const CC_REVIEW_REVIEW_RELOAD_ANSWER = "CC_REVIEW_REVIEW_RELOAD_ANSWER"
export const CC_REVIEW_REVIEW_RELOAD_EDIT = "CC_REVIEW_REVIEW_RELOAD_EDIT"
